module.exports = __webpack_public_path__ + "img/clock.2e67857e.svg";